export const CLIENTS_TABS = ["active", "pending", "archived"] as const;

export type ClientsTab = (typeof CLIENTS_TABS)[number];

/**
 * Each tab fully partitions the client list by `account_status`. Values are pinned
 * to the exact statuses the client-list endpoint accepts (`active`, `removed`,
 * `pending`) — sending any other value makes the backend return ZERO rows.
 *
 * - "My Clients" → active
 * - "Pending"    → pending (invited, account setup not complete)
 * - "Archived"   → removed (access revoked / inactive)
 */
const TAB_STATUSES: Record<ClientsTab, string[]> = {
  active: ["active"],
  pending: ["pending"],
  archived: ["removed"],
};

/** Coerce a raw `?tab` query value to a known tab, defaulting to `active` (My Clients). */
export const parseClientsTab = (value: unknown): ClientsTab =>
  value === "pending" ? "pending" : value === "archived" ? "archived" : "active";

/**
 * The `account_status` set a tab queries. Since each tab maps to exactly one status,
 * the tab alone determines the query (there is no in-tab Status filter to narrow by).
 */
export const getClientTabStatuses = (tab: ClientsTab): string[] => TAB_STATUSES[tab];
